import { createFileRoute } from '@tanstack/react-router'

import { Styleguide } from '@/styleguide/internal/Styleguide'

export const Route = createFileRoute('/styleguide/internal')({
  component: Styleguide,
})
